(function($) {
    var handleOptionClicked = function(event) {
        clickTarget = event.currentTarget;
        
        if ($(clickTarget).attr('disabled')) {
            event.preventDefault();
        } 
    };

    $(document).ready(function() {
        $('.navigation-button').click(handleOptionClicked);
        
        $.getJSON('database/list', {
                requestType: 'list', 
                nocache: new Date().getTime()
            }, 
            function(data) {
                // Did we get a successful return?
                if (!data.success || !data[dbmsHost_property]) {
                    $('.navigation-button.email-settings').attr('disabled', 'disabled');
                    $('.navigation-button.host-connection-settings').attr('disabled', 'disabled');
                    $('.navigation-button.licensing-settings').attr('disabled', 'disabled');

                    $('.navigation-button.email-settings > a').attr('title', disabledOptionTitle);
                    $('.navigation-button.host-connection-settings > a').attr('title', disabledOptionTitle);
                    $('.navigation-button.licensing-settings > a').attr('title', disabledOptionTitle);
                }
            }
        );
    });
})(jQuery);